import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PropsWithChildren } from 'react';

export const queryClient = new QueryClient({
  logger: {
    log: console.log,
    error: process.env.NODE_ENV === 'test' ? () => {} : console.error,
    warn: console.warn,
  },
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
    },
  },
});

export default function ReactQueryProvider({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
